import apiClient from "./api.client.service";

class AppIntegrationService {
  private APIBaseUrl: string;

  constructor() {
    this.APIBaseUrl = process.env.REACT_APP_API_BASE_URL ?? "";
  }

  async getAllConnectedApps() {
    try {
      const response = await apiClient.get(
        `${this.APIBaseUrl}/app-integration/connected-apps`
      );
      return response.data;
    } catch (error: any) {
      console.error(
        "🚀 ~ AppIntegrationService ~ getAllConnectedApps ~ error:",
        error
      );
      return {
        success: false,
        message: error.message,
        data: null,
      };
    }
  }

  async disconnectApp(appCredentialId: string) {
    try {
      const response = await apiClient.delete(
        `${this.APIBaseUrl}/app-integration/connected-apps/${appCredentialId}`
      );
      return response.data;
    } catch (error: any) {
      console.error(
        "🚀 ~ AppIntegrationService ~ disconnectApp ~ error:",
        error
      );
      return {
        success: false,
        message: error.message,
        data: null,
      };
    }
  }

  async generateAPIKey(appCredentialId: string) {
    try {
      const response = await apiClient.post(
        `${this.APIBaseUrl}/app-integration/connected-apps/${appCredentialId}/generate-api-key`
      );
      return response.data;
    } catch (error: any) {
      console.error(
        "🚀 ~ AppIntegrationService ~ generateAPIKey ~ error:",
        error
      );
      return {
        success: false,
        message: error.message,
        data: null,
      };
    }
  }

  async validateZohoRecruitConnection(code: string) {
    try {
      const response = await apiClient.post(
        `${this.APIBaseUrl}/app-integration/zoho/connect/verification`,
        {
          code,
        }
      );
      return response.data;
    } catch (error: any) {
      console.error(
        "🚀 ~ AppIntegrationService ~ validateZohoRecruitConnection ~ error:",
        error
      );
      return {
        success: false,
        message: error.message,
        data: null,
      };
    }
  }

  async validateLeverHireConnection(code: string) {
    try {
      const response = await apiClient.post(
        `${this.APIBaseUrl}/app-integration/lever/connect/verification`,
        {
          code,
        }
      );
      return response.data;
    } catch (error: any) {
      console.error(
        "🚀 ~ AppIntegrationService ~ validateLeverHireConnection ~ error:",
        error
      );
      return {
        success: false,
        message: error.message,
        data: null,
      };
    }
  }

  async processZohoRecruitApplication(candidateId: string, jobPostId: string) {
    try {
      const payload = {
        candidateId,
        jobPostId,
      };
      const response = await apiClient.post(
        `${this.APIBaseUrl}/ats/process/zoho`,
       payload 
      );
      return response.data;
    } catch (error: any) {
      console.error(
        "🚀 ~ AppIntegrationService ~ processZohoRecruitApplication ~ error:",
        error
      );
      return null;
    }
  }
}

const appIntegrationService = new AppIntegrationService();
export default appIntegrationService;
